import { getError } from "@/utils/helpers";
import NplanBvService from "@/services/nplan/NplanBvService";

export const namespaced = true;

export const state = {
  bv_planSingle: [],
  loading: false,
  error: null,
};

export const mutations = {
  SET_BVPLANSINGLE(state, bv_planSingle) {
    state.bv_planSingle = bv_planSingle;
  },
  SET_LOADING(state, loading) {
    state.loading = loading;
  },
  SET_ERROR(state, error) {
    state.error = error;
  },
};

export const actions = {
  getBVplan({ commit }, UserId) {
    commit("SET_LOADING", true);

    NplanBvService.getMain(UserId)
      .then((response) => {
        commit("SET_BVPLANSINGLE", response.data.data);
      })
      .catch((error) => {
        commit("SET_LOADING", false);
        commit("SET_ERROR", getError(error));
      })
      .finally(() => {
        commit("SET_LOADING", false);
      });
  },
};
export const getters = {
  bv_planSingle: (state) => {
    return state.bv_planSingle;
  },
  loading: (state) => {
    return state.loading;
  },
  error: (state) => {
    return state.error;
  },
};
